module.exports = __webpack_public_path__ + "assets/images/notify-Off.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/notify-Off.png
// module id = 1520
// module chunks = 1